import classNames from "classnames"
import React, { useState } from "react"
import DatePeriodPicker, { IDatePeriod } from "../../components/datePeriodPicker/datePeriodPicker"
import { IOption } from "../../components/selects/select"
import { useSystemSettingsContext } from "../../system/providers/systemSettingsProvider"
import styles from "./DatePeriodPanelV2.module.scss"
import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"
import { Select, Tooltip } from 'antd'

export const DateStringsFormat = "MM/dd/yyyy HH:mm:ss"
const { Option } = Select
type Period = "day" | "week" | "month" | "year"
export interface IDatePeriodPanelProps {
    datePeriod: IDatePeriod
    onDatePeriodChange: (value: IDatePeriod, dateStrings: [string, string]) => void
    disabled?: boolean
    label?: string
    inline?: boolean
    showTime?: boolean
    className?: string
}

export const DatePeriodPanelV2: React.FC<IDatePeriodPanelProps> = (props) => {

    const [selectedValue, setSelectedValue] = useState<string>('')
    const calendarHeight = useSystemSettingsContext().Calendar
    const { t } = useTranslation();
    const baseT = (value: string) => t('documents.invoice.' + value);   

    function getPeriod(p?: Period): IDatePeriod {
        const now = DateTime.now();

        switch (p) {
            case "day": return { startDate: now.startOf('day'), endDate: now.endOf('day') }
            case "week": return { startDate: now.startOf('week'), endDate: now }
            case "month": return { startDate: now.startOf('month'), endDate: now }
            case "year": return { startDate: now.startOf('year'), endDate: now }
            default: return { startDate: null, endDate: null }
        }
    }

    const handleSelectChange = (value: string) => {
        setSelectedValue(value)
        const period = getPeriod(value as Period)
        const dateStrings: [string, string] = [
            period.startDate?.toFormat(DateStringsFormat) || '',
            period.endDate?.toFormat(DateStringsFormat) || ''
        ]
        props.onDatePeriodChange(period, dateStrings)
    }

    return (
        <div className={classNames(styles.datePeriodPanel, props.inline && styles.datePeriodInline)}>
            {props.label && <label className={styles.datePeriodPanel__label}>{props.label}</label>}
            <div className={styles.datePeriodPanel__wrapper}>
                <DatePeriodPicker
                    disabled={props.disabled ?? false}
                    calendarHeight={calendarHeight}
                    period={props.datePeriod}
                    onPeriodChange={(value) => {
                        const dateStrings: [string, string] = [value.startDate?.toFormat(DateStringsFormat) as string || '', value.endDate?.toFormat(DateStringsFormat) as string || '']
                        props.onDatePeriodChange(value, dateStrings)
                        setSelectedValue('')
                    }}
                />
                <div className={styles.datePeriodPanel__period}>
                    <Select
                        className={classNames(styles.documentsFilteringPanelV2__select, styles.customSelect)}
                        value={selectedValue || undefined}
                        onChange={handleSelectChange}
                        disabled={props.disabled}
                        placeholder="Выберите период"
                    >
                        <Option value="day">{baseT('thisDay')}</Option>
                        <Option value="week">{baseT('thisWeek')}</Option>
                        <Option value="month">{baseT('thisMonth')}</Option>
                        <Option value="year">{baseT('thisYear')}</Option>
                    </Select>

                </div>
            </div>
        </div>
    )
} 
